// Open Contracting (OCDS) public pages — no authentication (authRequired: false).
export default [
    {
        path: "/welcome",
        name: "public-landing",
        meta: { title: "Welcome", authRequired: false },
        component: () => import("../views/public/PublicLanding.vue"),
    },
    {
        path: "/ocds-data",
        name: "ocds-data",
        meta: { title: "Open Contracting Data", authRequired: false },
        component: () => import("../views/ocds/OcdsData.vue"),
    },
    {
        path: "/records",
        name: "ocds-records",
        meta: { title: "OCDS Records", authRequired: false },
        component: () => import("../views/ocds/OcdsRecords.vue"),
    },
    {
        path: "/record-packages",
        name: "ocds-record-packages",
        meta: { title: "OCDS Record Packages", authRequired: false },
        component: () => import("../views/ocds/OcdsRecordPackages.vue"),
    },
    {
        path: "/ocds-reports",
        name: "ocds-reports",
        meta: { title: "OCDS Reports", authRequired: false },
        component: () => import("../views/ocds/OcdsReports.vue"),
    },
    {
        path: "/ocds-reports/:key",
        name: "ocds-report",
        meta: { title: "OCDS Report", authRequired: false },
        component: () => import("../views/ocds/OcdsReport.vue"),
    },
];
